import * as React from "react";

import { Helmet } from 'react-helmet';

import MainBanner from "../components/MainBanner";


// markup
const IndexPage = () => {
  return (
    <div>
      <Helmet>
        <script src="https://buchung.treatwell.at/common/venue-menu/javascript/widget-button.js?v1"></script>
      </Helmet>
      <MainBanner text={'Hairzlich Willkommen'}/>
    </div>
  )
}

export default IndexPage
